// extracted by mini-css-extract-plugin
export var core = "layout-module--core--27fbd";